'use client'

import {
  keyframes, styled, useTheme,
} from '@mui/material'
import * as React from 'react'

type SparkleBurstProps = React.PropsWithChildren<{
  triggerKey: string | number | boolean
  lifespanMs?: number
  size?: number
}>

const comeInOut = keyframes`
  0% { transform: translate(-50%,-50%) scale(0); opacity: 0; }
  50% { transform: translate(-50%,-50%) scale(1); opacity: 1; }
  100% { transform: translate(-50%,-50%) scale(0); opacity: 0; }
`
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(180deg); }
`

const Wrapper = styled('span')({
  position: 'relative',
  display: 'inline-block',
})
const Child = styled('span')({
  position: 'relative',
  zIndex: 1,
})
const SparkleWrap = styled('span')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  pointerEvents: 'none',
  animation: `${comeInOut} 700ms ease-in-out forwards`,
  zIndex: 2,
})
const SparkleSvg = styled('svg')({
  display: 'block',
  animation: `${spin} 900ms linear`,
})

export const SparkleBurst: React.FC<SparkleBurstProps> = ({
  children,
  triggerKey,
  lifespanMs = 800,
  size = 18,
}) => {
  const theme = useTheme()
  const color = theme.vars?.palette?.success?.main || theme.palette.success.main
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
    setShow(true)
    const id = globalThis.setTimeout(() => setShow(false), lifespanMs)
    return () => globalThis.clearTimeout(id)
  }, [triggerKey, lifespanMs])

  const path
    = 'M26.5 25.5C19.0043 33.3697 0 34 0 34C0 34 19.1013 35.3684 26.5 43.5C33.234 50.901 34 68 34 68C34 68 36.9884 50.7065 44.5 43.5C51.6431 36.647 68 34 68 34C68 34 51.6947 32.0939 44.5 25.5C36.5605 18.2235 34 0 34 0C34 0 33.6591 17.9837 26.5 25.5Z'

  return (
    <Wrapper>
      {show && (
        <SparkleWrap>
          <SparkleSvg width={size} height={size} viewBox="0 0 68 68" fill="none">
            <path d={path} fill={color} />
          </SparkleSvg>
        </SparkleWrap>
      )}
      <Child>{children}</Child>
    </Wrapper>
  )
}
